import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IDescriptionInput {
	changeDescription: (value: string) => void;
}

const DescriptionInput: React.FC<IDescriptionInput> = ({ changeDescription }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterDescription') },
			{ max: 100, message: tForm('fieldCannotBeMoreThanCharactersLong', { count: 100 }) },
		],
		[t],
	);

	return (
		<FormInput
			testId="DescriptionInput"
			name="description"
			label="descriptionLabel"
			onChange={changeDescription}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DescriptionInput);
